import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableSortLabel } from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { Button, useFormControl } from '@material-ui/core';
import { useHistory, useRouteMatch } from "react-router-dom";
import { getDate, prospectDetailsPath, searchFilter, handleSort } from "../utils/varialbles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Draggable from 'react-draggable';
import http from "../services/httpService";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { Grid, Typography, TextField, Checkbox, FormControlLabel, Select, MenuItem } from '@material-ui/core';
import toast, { Toaster } from 'react-hot-toast';




const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: 30
    },
    lableColor: {
        color: "#393939"
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    checkboxLabelA: {
        fontWeight: 800,
    }, select: {
        height: 36,
        width: 235,

    }
}));

function AddRole({ changeAciveTab, getState }) {

    const classes = useStyles();
    let history = useHistory();
    const [rolesDropDowm, setRolesDropDowm] = useState([])
    const form = {
        "role": "",
        "mm1": false,
        "mm2": false,
        "mm3": false,
        "mm4": false,
        "mm5": false,
        "mm6": false,
        "mm7": false,
        "mm8": false,
        "mm9": false,
        "mm10": false,
        "mm11": false,
        "sub1__1": false,
        "sub1__2": false,
        "sub1__3": false,
        "sub2__4": false,
        "sub2__5": false,
        "sub2__6": false,
        "sub2__7": false,
        "sub2__8": false,
        "sub3__9": false,
        "sub3__10": false,
        "sub6__11": false,
        "sub6__12": false,
        "sub8__13": false,
        "sub8__14": false,
        "sub9__15": false,
        "sub9__16": false,
        "sub10__17": false,
        "sub10__18": false,
    }

    const [formObject, setFormObject] = useState(form);
    const handleChange = (e) => {
        setFormObject({
            ...formObject,
            [e.target.name]: e.target.checked
        });
    }
    const handleRoleChange = (e) => {
        setFormObject({
            ...formObject,
            [e.target.name]: e.target.value
        });
    }
    const permissionList = [{
        "name": "Prospect Manager", "id": 1,
        children: [
            { "name": "Overview", "id": 1, "parent": 1 },
            { "name": "Discount Manager", "id": 2, "parent": 1 },
            { "name": "Ticket Manager", "id": 3, "parent": 1 },
        ]
    }, {
        "name": "Investment Manager", "id": 2,
        children: [
            { "name": "Overview", "id": 4, "parent": 2 },
            { "name": "Portfolio", "id": 5, "parent": 2 },
            { "name": "Investments", "id": 6, "parent": 2 },
            { "name": "Discount Manager", "id": 7, "parent": 2 },
            { "name": "Important", "id": 8, "parent": 2 }]
    }, {
        "name": "APART", "id": 3,
        children: [
            { "name": "Lists", "id": 9, "parent": 3 },
            { "name": "EFG Admin", "id": 10, "parent": 3 },
            // {"name":"Stock Closure Upload","id":6,"parent":3},
        ]
    },
    {
        "name": "CEO Dashboard", "id": 4, children: []
    },
    {
        "name": "Broker Manager", "id": 5, children: []
    },
    {
        "name": "User Management", "id": 6,
        children: [
            { "name": "Add New Role", "id": 11, "parent": 6 },
            { "name": "Add New User", "id": 12, "parent": 6 }]
    }, {
        "name": "Referral Manager", "id": 7, children: []
    }, {
        "name": "Content Management System", "id": 8,
        children: [
            { "name": "Published Posts", "id": 13, "parent": 8 },
            { "name": "Archived Posts", "id": 14, "parent": 8 }]
    },
    {
        "name": "Beige - Event Management", "id": 9,
        children: [
            { "name": "Notification Manager", "id": 15, "parent": 9 },
            { "name": "Discount Manager", "id": 16, "parent": 9 }]
    },
    {
        "name": "Lookup Manager", "id": 10,
        children: [
            { "name": "Lookup Details List", "id": 17, "parent": 10 },
            { "name": "Add New Lookup Detail", "id": 18, "parent": 10 }]
    }, {
        "name": "Call Requests", "id": 11, children: []
    }

    ]
    const handleSubmit = (e) => {
        let finalObject = { ...formObject };
        let SubmitObject = {};
        Object.keys(finalObject).map((key, index) => {
            if (key.indexOf("mm") !== -1) {
                let splittedKey = key.split("mm");
                let menuItem = permissionList.filter(obj => { return obj.id == splittedKey[1] })
                if (menuItem[0] && !SubmitObject.hasOwnProperty(menuItem[0]['name'])) {
                    SubmitObject[menuItem[0]['name']] = finalObject[key] ? Number(splittedKey[1]) : null
                }
            } else if (key.indexOf("sub") !== -1) {
                let splittedKey = key.split("sub");
                let finalsplittedKey = splittedKey[1].split("__");
                let menuItem = permissionList.filter(obj => { return obj.id == finalsplittedKey[0] })
                if (!SubmitObject.hasOwnProperty(menuItem[0]['name'])) {
                    SubmitObject[menuItem[0]['name']] = finalObject[key] ? {
                        "mainmenuid": Number(finalsplittedKey[0]),
                        "submenuids": [Number(finalsplittedKey[1])]
                    } : null
                } else if (!SubmitObject[menuItem[0]['name']]) {
                    SubmitObject[menuItem[0]['name']] = finalObject[key] ? {
                        "mainmenuid": Number(finalsplittedKey[0]),
                        "submenuids": [Number(finalsplittedKey[1])]
                    } : null
                } else if (SubmitObject[menuItem[0]['name']].hasOwnProperty("submenuids") && finalObject[key]) {
                    SubmitObject[menuItem[0]['name']]["submenuids"].push(Number(finalsplittedKey[1]))
                }
            } else if (key === "role") {
                let role = rolesDropDowm.filter(role => {
                    return role.id === finalObject.role
                })
                if (role && role.length > 0) {
                    SubmitObject.role = role[0]['role'];
                } else {
                    SubmitObject.role = null;
                }
            }
        })
        if (SubmitObject.role) {

            http.post("/permission_manager", SubmitObject).then((response) => {
                if (response.data.statusCode === 0) {
                    toast.success(response.data.data);
                    changeAciveTab("Roles");

                } else {
                    toast.error(response.data.data);
                }
            }).catch((error) => {
            })
        } else {
            toast.error("Please Select a Role..!");
        }

    }

    useEffect(() => {
        localStorage.removeItem("prospectFilter");
        localStorage.removeItem("investmentFilter");
        localStorage.removeItem("ticketFilter");
        localStorage.removeItem("internalFilter")
        localStorage.removeItem("selectedfiltersdata");
        localStorage.removeItem('selectedinvestorfiltersdata')

        http.get("/permission_manager").then(res => {
            if (res && res.data && res.data.Roles && Array.isArray(res.data.Roles) && res.data.Roles.length > 0) {
                setRolesDropDowm(res.data.Roles);
            }
        })
        getState({})
    }, []);
    return (
        <Grid container component="main" style={{ marginTop: 30 }}>

            <Grid item xs={false} sm={5} md={5} style={{ paddingLeft: 30 }}>
                {/* <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button> */}
            </Grid>
            <Grid item xs={false} sm={5} md={5} >
                <Typography color="textPrimary" variant="h5" style={{ marginBottom: 20 }}>Add/Update Roles and Permissions</Typography>
            </Grid>
            <Grid container className={classes.paper, 'overviewbar'}>
                <Grid item xs={false} sm={4} md={4}></Grid>
                <Grid item xs={false} sm={1} md={1} align="center">
                    <Typography className={classes.lableColor} id="emailIDLable" variant="h6">Role</Typography>
                </Grid>

                <Grid item xs={false} sm={5} md={5} >
                    <Select displayEmpty labelId={"Role" + "label"} id="roleSelect" variant="outlined" className={classes.select} onChange={handleRoleChange} value={(formObject['role']) ? formObject['role'] : ""} name={"role"}>
                        <MenuItem value="">Select</MenuItem>
                        {rolesDropDowm.map((option, index) => {
                            return <MenuItem value={option.id} key={"role" + index}>{option.role}</MenuItem>
                        })}
                        )
                    </Select>
                </Grid>
            </Grid>
            <Grid container style={{ marginTop: 50 }} className={'overviewbar'}>
                <Grid item xs={false} sm={6} md={6} align="right">
                    <Typography className={classes.lableColor} id="emailIDLable" variant="h6">Permissions</Typography>
                </Grid>
            </Grid>
            <Grid container style={{ marginTop: 50, paddingLeft: 30 }}>
                <Grid item xs={12} sm={3} md={3} >

                    {
                        permissionList.slice(0, 4).map((obj, inx) => {
                            return (

                                <Grid container key={inx + "o"}>

                                    <Grid item sm={12} md={12}>

                                        {(obj && obj.children.length > 0) ? <Grid >
                                            <Typography variant="h6">
                                                {obj.name}
                                            </Typography>
                                            {
                                                obj.children.map((sub, subinx) => {
                                                    return (
                                                        <Grid item xs={12} key={subinx + "sub"}>
                                                            <FormControlLabel
                                                                control={<Checkbox
                                                                    checked={formObject["sub" + obj.id + "__" + sub.id]}
                                                                    color="primary" onChange={handleChange}
                                                                    name={"sub" + obj.id + "__" + sub.id} />}
                                                                label={sub.name}
                                                            />
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid> : (obj.id && obj.name) ? <Grid item xs={12} sm={12} md={12} ><FormControlLabel
                                            control={<Checkbox checked={formObject["mm" + obj.id]} color="primary" onChange={handleChange} name={"mm" + obj.id} />}
                                            label={obj.name}
                                            classes={{ label: classes.checkboxLabelA }}
                                        /> </Grid> : ""

                                        }
                                    </Grid>
                                </Grid>

                            )
                        })
                    }
                </Grid>
                <Grid item xs={12} sm={3} md={3} >

                    {
                        permissionList.slice(4, 11).map((obj, inx) => {
                            return (

                                <Grid container key={inx + "o"}>
                                    {(obj && obj.children.length > 0) ? <Grid >
                                        <Typography variant="h6">
                                            {obj.name}
                                        </Typography>
                                        {
                                            obj.children.map((sub, subinx) => {
                                                return (
                                                    <Grid item xs={12} key={subinx + "sub"}>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={formObject["sub" + obj.id + "__" + sub.id]} color="primary" onChange={handleChange} name={"sub" + obj.id + "__" + sub.id} />}
                                                            label={sub.name}
                                                        />
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid> : (obj.id && obj.name) ? <Grid item xs={12} sm={12} md={12} ><FormControlLabel
                                        control={<Checkbox checked={formObject["mm" + obj.id]} color="primary" onChange={handleChange} name={"mm" + obj.id} />}
                                        label={obj.name}
                                        classes={{ label: classes.checkboxLabelA }}
                                    /> </Grid> : ""

                                    }
                                </Grid>

                            )
                        })
                    }
                </Grid>
                <Grid item xs={12} sm={6} md={6} className={"roleParent"}>
                    <Grid container >
                        <Grid item xs={12} sm={0} md={0} lg={3}></Grid>
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                            <Button variant="outlined" color="primary" className="roleBtn" >Cancel</Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                            <Button variant="contained" color="primary" className="roleBtn" onClick={handleSubmit}>Save</Button>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid >
    );
}
export default AddRole;